import React, { useEffect, useRef } from "react";
//note: this video assumes it will be played via lazy loading algorithm. It will not play automatically without that.
export default function AutoPlaySilentVideo(props) {
  const videoRef = useRef(undefined);
  useEffect(() => {
    videoRef.current.defaultMuted = true;
  });
  return (
    <video
      poster={props.poster}
      className={props.className}
      ref={videoRef}
      loop
      autoPlay
      muted
      playsInline
      immediate={props.immediate}
    >
      <source
        data-src={props.webmURL}
        src={props.immediate ? props.webmURL : null}
        type="video/webm"
      />
      <source
        data-src={props.mp4URL}
        src={props.immediate ? props.mp4URL : null}
        type="video/mp4"
      />
    </video>
  );
}
